import { render, staticRenderFns } from "./ExtModules.vue?vue&type=template&id=53b0d3ec"
import script from "./ExtModules.vue?vue&type=script&lang=js"
export * from "./ExtModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports